var constants = {
    baseUrl: 'https://conferenceadmin.digisurgeon.in/public/api/',
    // baseUrl:'http://127.0.0.1:8000/api/'
}

export default constants;